import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, makeStyles, MenuItem, Paper, Select, 
  TextField, Theme, Typography, Button, } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { DefaultInputProps } from '../../types/types';
import { API_elaboraIForfetari, GestParseFloatNaN } from '../../utils/functions';
import { SectionAlert } from '../../components/SectionAlert';

export default function InformazioniIniziali(props: DefaultInputProps) {
  const gClasses = globalStyles();
  const action = "changeInformazioniIniziali";
  const [global] = useGlobal<IGlobalState>();
  const { state } = props;

  const handleChange = (e: any) => {
    let { name, value } = e.target;
    props.handleChange(action, name, value);
  }

  const handleChangeSelect = (e: any) => {
    // handleChange(e);
    let { name, value } = e.target;
    props.handleChange(action, name, value);
    API_elaboraIForfetari(props, global, name, value, action, true);
  }

  const handleChangeChecked = (e: any) => {
    let { name, checked } = e.target;
    props.handleChange(action, name, checked);
    API_elaboraIForfetari(props, global, name, checked, action, true);
  }

  // const handleChangeSelectCompany = (e: any) => {
  //   let { name, value } = e.target;
  //   // setCompanyId(value);
  //   loadAgencies(value);
  // }
  
  // const handleChangeSelectAgency = (event: ChangeEvent<{}>, value: Agency | null, reason: AutocompleteChangeReason) => {
  //   // let { name, value } = e.target;
  //   console.log('agency id: ' + value?.Id);
  //   setAgency(value);
  // }
  // const handleChangeSelectAgency = (e: any) => {
  //   let { name, value } = e.target;
  //   // setCompanyId(value);
  //   // setAgencyId(value);
  // }
  
  // const handleLoadData = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  //   if (cfImpresa !== null && cfImpresa !== '') {

  //   }
  // }


  let error = state.nomeCognome === undefined || state.nomeCognome === "";
  let errorImpresaFamigliare = state.tipologia === "PROFESSIONE" && state.famigliare === true;

  
  return (
    <Paper className={gClasses.mainPaper}>
      <SectionTitle text="Informazioni iniziali"></SectionTitle>
      <Grid container>
          <Grid item lg={4} xs={12}>
            <TextField
              required
              error={error}
              helperText={error ? "Campo obbligatorio" : ""}
              id="nomeCognome"
              name="nomeCognome"
              label="Cognome e nome"
              value={state.nomeCognome}
              onChange={handleChange} 
              // onBlur={handleBlur}
              className={gClasses.textField}
              InputLabelProps={{
                shrink: true,            
              }}
              // margin="dense"
            />
          </Grid>
          <Grid item lg={4} xs={12}>
          <FormControl className={gClasses.formControl}>
            <InputLabel htmlFor="tipologia">Tipologia</InputLabel>
            <Select
              className={gClasses.select}
              value={state.tipologia}
              onChange={handleChangeSelect}
              // onChange={handleChange}
              inputProps={{
                name: 'tipologia',
                id: 'tipologia',
              }}
            >
              <MenuItem value={"NON DEFINITO"}>Non definito</MenuItem>
              <MenuItem value={"IMPRESA"}>Impresa</MenuItem>
              <MenuItem value={"PROFESSIONE"}>Professione</MenuItem>
            </Select>
          </FormControl>
          </Grid>
          <Grid item lg={4} xs={12}>
            <FormControlLabel className={gClasses.bottomControlLabel}
              labelPlacement="end"
              control={
                <Checkbox
                  checked={state.famigliare}
                  onChange={handleChangeChecked}
                  name='famigliare'
                  id='famigliare'
                  value={state.famigliare}
                  inputProps={{
                    'aria-label': 'primary checkbox'
                  }} 
                />
              } 
              label="Impresa famigliare" 
            />
            {errorImpresaFamigliare === true ? <Typography style={{ marginTop: "8px" }} variant="body1" color="error">Non coerente con tipologia</Typography> : <p></p>}
          </Grid>
        </Grid>
      <Grid container>
        <Grid item lg={4} xs={12}>
          <NumberField
            disabled={state.famigliare === undefined || state.famigliare === false}
            name="quotaCollab1"
            label={"Quota collab. 1"}
            value={state.quotaCollab1}
            onChange={handleChange} 
            // onBlur={handleBlur}
            min={0}
            max={49}
            symbol={"%"}
            forcedError={(GestParseFloatNaN(state.quotaCollab1) + GestParseFloatNaN(state.quotaCollab2)) > 49}
            forcedErrorMessage={"Errore: valore quote > 49"}
            className={gClasses.textField}
          ></NumberField>
        </Grid>
        <Grid item lg={4} xs={12}>
          <NumberField
            disabled={state.famigliare === undefined || state.famigliare === false || state.quotaCollab1 === undefined || state.quotaCollab1 === 0}
            name="quotaCollab2"
            label={"Quota collab. 2"}
            value={state.quotaCollab2}
            onChange={handleChange} 
            // onBlur={handleBlur}
            min={0}
            max={49}
            symbol={"%"}
            forcedError={(GestParseFloatNaN(state.quotaCollab1) + GestParseFloatNaN(state.quotaCollab2)) > 49}
            forcedErrorMessage={"Errore: valore quote > 49"}
            className={gClasses.textField}></NumberField>
        </Grid>
        <Grid item lg={4} xs={12} style={{padding: '6px 0 0 18px'}}>
          <Button variant="contained" color="primary" 
            onClick={props.handleOpenLoadData} 
            disabled={state.tipologia === "NON DEFINITO" || state.nomeCognome === "" || state.nomeCognome === null}            
          >
            Carica dati
          </Button>
        </Grid>
      </Grid>
    </Paper>);
}